<component :is="episodeComponent"></component><pageFooter></pageFooter>